import { InjectionToken } from '@angular/core'
import { Converter, Facet } from '@spartacus/core'

export const MB_HOMEPAGE_FACETS_NORMALIZER = new InjectionToken<
  Converter<any, Facet[]>
  >('MbHomepageFacetsNormalizer')
